import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { invalidate, useQueryClient } from "@msuite/ui/query";
import React from "react";
import { Can } from "@/components/citadel";
import { EditVehicleModal } from "@/modals/vehicles/edit-vehicle-modal";

/** Props Interface */
interface VehicleMenuProps {
	vehicleId: string;
}

export function VehicleMenu({ vehicleId }: VehicleMenuProps) {
	/** Hooks */
	const { t } = useTranslation();
	const editVehicleModal = useDisclosure();
	const qc = useQueryClient();

	/** Functions */
	async function handleOnCompleteEdit() {
		await qc.invalidateQueries({
			predicate: invalidate([vehicleId]),
		});
	}

	/** Render */
	return (
		<React.Fragment>
			<Can
				action="update"
				subject="Vehicle"
			>
				<Button
					variant="primary"
					icon={<Icon name="Edit" />}
					onClick={editVehicleModal.onOpen}
				>
					{t("general.edit")}
				</Button>
			</Can>
			{editVehicleModal.isOpen && (
				<EditVehicleModal
					vehicleId={vehicleId}
					onClose={editVehicleModal.onClose}
					isOpen={editVehicleModal.isOpen}
					onComplete={handleOnCompleteEdit}
				/>
			)}
		</React.Fragment>
	);
}
